import { compose, not } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

export const equalOrThreeDashes = (...args) => {
	return args.filter(compose(not, isNilOrEmpty)).join(' ') || '---';
};

export const equalOrValue = (value, ...args) => {
	return args.filter(compose(not, isNilOrEmpty)).join(' ') || value;
};

export const equalOrZero = (...args) => {
	return args.filter(compose(not, isNilOrEmpty)).join(' ') || 0;
};
